const globalData = require('./globalData');
const axios = require("axios")
const axios_instance = require("axios").create({
    baseURL: process.env.NODE_ENV === 'development' ?
        process.env.VUE_APP_HOST_DEV :
        (globalData.staging ? process.env.VUE_APP_HOST_STA : process.env.VUE_APP_HOST_PRO),
    timeout: 60000
});

async function get(url, params={}) {
    return axios_instance.get(url, {
        headers: {
            'Authorization': `Bearer ${globalData.token}`,
        }, params: params
    }).then(function (response) {
        return response.data;
    }).catch( (err) => {
        return {
            success: false,
            message: err.message
        }
    });
}

async function getWithConfig(url, config) {
    return axios_instance.get(url, config
    ).then(function (response) {
        return response.data;
    }).catch( (err) => {
        return {
            success: false,
            message: err.message
        }
    });
}


async function getExternal(url) {
    return axios.get(url, {
        headers: {
            "Content-Type": "application/json",
        }
    }).then(response => {
        return response;
    }).catch( (err) => {
        return err
    });
}

async function post(url, body, params = {}) {
    return axios_instance.post(url, body, {
        headers: {
            'Authorization': `Bearer ${globalData.token}`
        },
        params : params
    }).then(function (response) {
        return response.data;
    }).catch((err) => {
        return {
            success: false,
            message: err.message
        }
    });
}

module.exports = {
    get,
    getExternal,
    post,
    getWithConfig
};
